<template>

<section class="container section-large result-container mbl" :class="{ circleResultsAnimTwo: resultsClassOnOff }">

    <div class="is-flex is-align-items-center is-justify-content-center mb" :class="{ circleResultsAnim: resultsClassOnOff }">
        <q-circular-progress
        id="results" 
        show-value
        :value="circleScore"
        animation-speed="3500"
        :thickness="0.15"
        color="shade"
        track-color="grey-3"
        >
            <div class="circular-progress-text">
                <div v-if="weightedAvClassTitle != '180 credits required' && weightedAvClassTitle != 'Incalculable'">
                    <h2>{{ weightedAvClassTitle }}</h2>
                    <hr>
                    <h2>
                        <span>{{ weightedAvClass.toFixed(2) }}</span>
                    </h2>
                </div>
                <div v-else>
                    <h2>{{ weightedAvClassTitle }}</h2>
                </div>
            </div>
        </q-circular-progress>
    </div> 

    <div class="certificationGridColumn" :class="{circleResultsAnimTwo: resultsClassOnOff}">



            <div class="results-methods"> 
                <div class="methods">
                    <h2>How your classification is calculated</h2>
                    <div class="stats-container"> 
                        <div class="stats-container-flex">
                            <p class="cert-info-fin text-center">
                                Your classification is determined by a weighted average of your unit marks. For an award to be made at Merit level, you must gain an overall average of at least 60%. For an award to be made at Distinction level, you must gain an overall average of at least 70%.
                            </p>
                        </div>                   
                    </div>
                </div>  
            </div>

            <div class="results-final">

                <div>
                    <div>
                        <h2>Final Result</h2>

                        <div class="final-grade-layout"> 
                                <div class="stats-container-flex">
                                    <h3>Classification</h3>
                                    <p class="cert-info-fin">{{ weightedAvClassTitle }}</p>
                                </div>

                                <div class="stats-container-flex">
                                    <div v-if="weightedAvClassTitle === '180 credits required' || weightedAvClassTitle === 'Incalculable'">
                                        <h3>Mark</h3>
                                        <p class="cert-info-fin">{{ weightedAvClassTitle }}</p>
                                    </div>
                                    <div v-else>
                                        <h3>Mark</h3>
                                        <p class="cert-info-fin">{{ weightedAvClass.toFixed(2) }}</p>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
    <button title="Copy to clipboard" class="button is-large mts" @click="clipboard"><q-icon left name="content_copy"/>Copy to clipboard</button>
</section>

</template>

<script>
import { copyToClipboard } from 'quasar'
import { useQuasar } from 'quasar'
import { ref } from 'vue'
import Dialog from '@/components/Dialog.vue'

export default {

components: { Dialog },

props: ['resultsClassOnOff', 'weightedAvClassTitle', 'levelFourFinalGrade', 'LvFourTwentyFivePercent', 'LvFourOneHundredPercent', 'levelFiveFinalGrade', 'LvFiveSeventyFivePercent', 'weightedAvClass', 'methodOne', 'methodTwo', 'circleScore', 'methodSwitch', 'finalScore', 'postGradResults', 'component'],

setup(props, context){

const openCloseModal = ref(false)
const quasar = useQuasar()

quasar.notify.setDefaults({
    actions: [{ icon: 'close', color: 'white' }]
})

const closeModalBtn = () => {
    openCloseModal.value = false

    if( openCloseModal.value === false ) {
        document.documentElement.style.overflowY = 'scroll';
        document.documentElement.style.overflowX = 'hidden';
        document.body.scroll = "yes";     
    } 
}

const disableBackgroundScroll = () => {
    if( openCloseModal.value === true ) {
        document.documentElement.style.overflow = 'hidden';
        document.body.scroll = "no";
    } 
}

const clipboard = () => {

let pasteContent = 
// ref(`FINAL RESULT: ${props.weightedAvClassTitle}, ${props.finalScore.toFixed(2)};`)

ref(`FINAL RESULT: ${props.weightedAvClassTitle}${props.weightedAvClassTitle === "180 credits required" || props.weightedAvClassTitle === "Incalculable" ? "" : ', ' + props.finalScore.toFixed(2)};`)


    copyToClipboard(pasteContent.value)
    .then(() => { 
        quasar.notify({
        color: 'negative', message: 'You can now paste your grade wherever you like!', icon: 'content_paste_go', position: 'bottom', classes: 'notify-copy'
        })
    })
    .catch(() => {
        quasar.notify({
        color: 'negative', message: 'Something went wrong, try again!', icon: 'error', position: 'bottom', classes: 'notify-copy'
        })
    })
}

return {        
     clipboard,
     quasar,
     closeModalBtn,
     openCloseModal,
     disableBackgroundScroll,
}

}
}
</script>

